export default __webpack_public_path__ + "static/media/fivesenses.ca331d12.jpeg";